module.exports = __webpack_public_path__ + "media/images/admin/dropzone/success-ef674a1c15e51756ea400718d830d9b7.svg";